import React from 'react';
import { Typography, InputField, Box } from 'vindi-ds-components';
import useAdditionalFieldsHook from '../create/hooks/use_additional_fields';

const ApiArea = () => {
  const { apiArea } = useAdditionalFieldsHook();

  if (apiArea) {
    return (
      <Box display='flex' flexDirection='column' width='26.7em'>
        <Typography variant='subtitle1' component='h2'>
          Código para API
        </Typography>
        <InputField name='code' label='Código externo (opcional)' placeholder='Código para referência' />
      </Box>
    );
  }

  return (null);
};

export default ApiArea;
